import React from 'react';
import { Settings } from 'lucide-react';

const ScriptSettings = () => {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg shadow-sm">
      <div className="p-6 border-b border-slate-700">
        <div className="flex items-center">
          <Settings className="w-6 h-6 text-blue-400 mr-3" />
          <div>
            <h2 className="text-xl font-semibold text-slate-200">Script Settings</h2>
            <p className="text-slate-400 mt-1">Configure script execution settings and preferences</p>
          </div>
        </div>
      </div>

      <div className="p-6">
        <div className="text-center py-12">
          <Settings className="w-16 h-16 text-slate-600 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-slate-300 mb-2">Script Settings</h3>
          <p className="text-slate-400">This page will contain script configuration settings.</p>
        </div>
      </div>
    </div>
  );
};

export default ScriptSettings;